var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex items-center"},[_c('div',{staticClass:"mr-10 self-stretch bg-persimmon",class:[{ 'mr-0': _vm.barWidth === 0 }],style:({ width: (_vm.barWidth + "px") })}),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }